import React from 'react';
import SettingIcon from './SettingIcon';

export function ErrorModal({
  title = 'Unknown Error',
  message,
  isDismissable = false,
  onDismiss = Function.prototype,
  actionButton,
}) {
  return (
    <div className="as-Error-body">
      {isDismissable && (
        <button
          type="button"
          className="as-Error-dismissButton"
          onClick={onDismiss}
        >
          <shore-icon name="delete" />
        </button>
      )}
      <h2 className="as-Error-title">{title}</h2>
      {
        /* eslint-disable  react/no-danger */
        <p
          className="as-Error-message"
          dangerouslySetInnerHTML={{ __html: message }}
        />
        /* eslint-enable */
      }

      <div className="as-Error-icon">
        <SettingIcon />
      </div>
      {actionButton && (
        <a href={actionButton.href} className="as-Error-actionButton">
          {actionButton.title}
        </a>
      )}
    </div>
  );
}
